export const UploadImageIcon = () => (
  <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="#555" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
    <circle cx="8.5" cy="8.5" r="1.5" />
    <polyline points="21 15 16 10 5 21" />
    {/* Círculo do "Mais" (Plus) */}
    <circle cx="18" cy="18" r="5" fill="#f0f0f0" stroke="#555" />
    <line x1="18" y1="15" x2="18" y2="21" stroke="#555"/>
    <line x1="15" y1="18" x2="21" y2="18" stroke="#555"/>
  </svg>
);